import { createSelector } from "@ngrx/store";
import * as fromFeature from "../reducers";
import * as fromStudentMetrics from "../reducers/student-metrics.reducer";

// get studentMetrics state
export const getStudentMetricsState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state.studentMetrics
);

// get studentMetrics
export const getStudentMetrics = createSelector(
    getStudentMetricsState,
    fromStudentMetrics.getStudentMetrics
);

export const getStudentMetricsLoading = createSelector(
    getStudentMetricsState,
    fromStudentMetrics.getStudentMetricsLoading
);

export const getStudentMetricsLoaded = createSelector(
    getStudentMetricsState,
    fromStudentMetrics.getStudentMetricsLoaded
);
